<template>
  <div>
    <div
      v-if="open"
      class="backdrop"
      @click="$emit('close')"
    />
    <transition name="modal">
      <dialog
        v-if="open"
        :style="type==='error' ? 'backgroundColor: red' : ''"
        open
      >
        <slot />
      </dialog>
    </transition>
  </div>

  <!-- <div class="toast-wrapper" v-if="open">
         <transition name="modal">
      <div class="toast">You must enter a value for the todo</div>
       </transition>
    </div> -->
</template>

<script>
export default {
  emits: ['close'],
  props: ['open', 'type'],
};
</script>

<style>
/* .toast-wrapper {
  position: fixed;
  width: 100%;
  top: 20px;
}
.toast {
  padding: 20px;
  color: white;
  background: #42b983;
  border-radius: 10px;
  box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  margin: 0 auto;
} */

.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
.modal-enter-to,
.modal-leave-out {
  opacity: 1;
  transform: translateY(0);
}
.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
}

dialog {
  position: fixed;
  color: white;
  font-size: 2rem;
  top: 5vh;
  width: 50rem;
 
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  border-radius: 12px;
  padding: 1rem;
  background-color: #42b983;
  z-index: 100;
  border: none;
}
</style>
